import { useState } from 'react';

const UseModalGracias = () => {
  const [isShowingGracias, setIsShowingGracias] = useState(false);

  function toggleGracias() {
    setIsShowingGracias(!isShowingGracias);
  }

  return {
      UseModalGracias,
    isShowingGracias,
    toggleGracias,
  }
};

export default UseModalGracias;